const clickHelper = {
  down: {
    x: 0,
    y: 0,
    time: 0
  },
  real: false,
  isRealClick: function() {
    return this.real;
  }
};

window.addEventListener(
  "mousedown",
  event => {
    if (event.button != 0) return;

    clickHelper.real = false;
    clickHelper.down.x = event.x;
    clickHelper.down.y = event.y;
    clickHelper.down.time = Date.now();
  },
  {
    capture: true
  }
);

window.addEventListener(
  "mouseup",
  event => {
    if (event.button != 0) return;

    const dt = Date.now() - clickHelper.down.time;
    if (dt > 300) return;

    const dx = Math.abs(event.x - clickHelper.down.x);
    if (dx > 15) return;

    const dy = Math.abs(event.y - clickHelper.down.y);
    if (dy > 15) return;

    clickHelper.real = true;
  },
  {
    capture: true
  }
);

export default clickHelper;
